<template>
  <ElButton type="info" plain @click="emitExpandEvent">
    <span v-if="!expand"> DETAILED VIEW </span>
    <span v-else> SHORT VIEW </span>
  </ElButton>
</template>

<script>
export default {
  name: "ExpandView",
  props: {
    expand: {
      type: Boolean,
    },
  },
  methods: {
    emitExpandEvent() {
      this.$emit("expand");
    },
  },
};
</script>
